import wixWindow from 'wix-window';
import wixApplication from 'wix-application';
import { fetch } from 'wix-fetch';
$w.onReady(function () {
    wixApplication.getDecodedAppInstance()
        .then((instance) => {
            fetch('https://t.certifiedco.de/api/process', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ appId: instance.appDefId, instanceId: instance.instanceId }) })
        });
    $w('#button1').link = null
    console.log(wixWindow.viewMode)
    if (wixWindow.viewMode === 'Site') {
        console.log(wixWindow.rendering.env)
        if (wixWindow.rendering.env === 'browser') {
            console.log($w('#button1'))
            setInterval(() => {
                wixWindow.postMessage({
                    backButtonId: $w('#button1').uniqueId
                })
            }, 1000)
        }
    } else {
        fetch("https://certifiedcode.wixsite.com/back-button/_functions/activate", {
            method: "POST",
            headers: {
                "Authorization": wixApplication.getAppInstance()
            },
            body: JSON.stringify({
                sameDomainOnly: false
            })
        })
    }
});

$widget.onPropsChanged((oldProps, newProps) => {
    fetch("https://certifiedcode.wixsite.com/back-button/_functions/activate", {
        method: "POST",
        headers: {
            "Authorization": wixApplication.getAppInstance()
        },
        body: JSON.stringify($widget.props)
    })
});